import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import API from './plugins/api';
import './assets/tailwind.css';

import IconClose from './components/IconClose.vue'

Vue.component('icon-close', IconClose);
Vue.config.productionTip = false
Vue.use(API);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
